<template>
    <el-dialog 
    :modal-append-to-body="false"
    :title="openType === 'add' ? '新增收货地址' : '编辑收货地址'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="815px"
    custom-class="customModal">
    
    <el-form :model="ruleForm"  :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="padding: 0px 15px 0 4px">
        <el-form-item label="收货人姓名" prop="consignee" style="width:300px">
            <el-input type="text" v-model="ruleForm.consignee" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile" style="width:300px">
            <el-input type="text" v-model="ruleForm.mobile" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所在地区" required>
            <el-col :span='6'>
                <el-form-item prop="province">
                    <el-select v-model="ruleForm.province" style="width:150px" @change="getArea(2,ruleForm.province)">
                        <el-option v-for="item in province" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span='6' v-if="ruleForm.province">
                <el-form-item prop="city">
                    <el-select v-model="ruleForm.city" style="width:150px" @change="getArea(3,ruleForm.city)" >
                        <el-option v-for="item in city" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span='6' v-if="ruleForm.city">
                <el-form-item prop="district">
                    <el-select v-model="ruleForm.district" style="width:150px" @change="getArea(4,ruleForm.district)">
                        <el-option v-for="item in district" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span='6' v-if="town.length>0">
                <el-form-item prop="town">
                    <el-select v-model="ruleForm.town" style="width:150px" @change="selectChange">
                        <el-option v-for="item in town" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
            <el-input type="textarea" v-model="ruleForm.address" auto-complete="off" style="width:653px;"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码" prop="zipcode" style="width:300px">
            <el-input type="text" v-model="ruleForm.zipcode" auto-complete="off"></el-input>
        </el-form-item>
        
        <el-form-item label="" prop="is_default">
            <el-checkbox label="设置为默认地址" name="type" v-model="ruleForm.is_default"></el-checkbox>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">保存</el-button>
            <el-button @click="close">取消</el-button>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
     
    </div>
  </el-dialog>
</template>

<script>
const province = []
const city = []
const district = []
const town = []
import { UserCenterService } from '../../../service/userCenter.service'
  export default {
    data() {
         var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            } 
            else {
                const reg = /^1[3456789]\d{9}$/
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error('请输入正确的手机号'));
                }
            }
        }
      return {
        province,
        city,
        district,
        town,
        visible: false,
        openType: '',
        formValue: { },
        ruleForm: {
            
        },
        rules: {
            address: [
                { required: true, message: '请输入详细地址', trigger: 'blur' }
            ],
            zipcode: [
                { min: 5, max:5,  message: '长度应为5个字符', trigger: 'blur' }
            ],
            consignee: [
                { required: true, message: '请输入收货人姓名', trigger: 'blur' }
            ],
            mobile: [
                { required: true, message: '请输入手机号码', trigger: 'blur' },
                { validator: checkPhone, trigger: 'blur'},
            ],
            province: [
                { required: true, message: '请选择收货地址', trigger: 'change'}
            ],
            city: [
                { required: true, message: '请选择收货地址', trigger: 'change'}
            ],
            district: [
                { required: true, message: '请选择收货地址', trigger: 'change'}
            ],
        },
      }
    },
    methods: {
      async open(type, data) {
        if (type === 'add') {
          this.reset();
        } else if (type === 'edit') {
          this.ruleForm = JSON.parse(JSON.stringify(data))
          this.ruleForm.is_default = data.is_default ? 1 : 0
          this.getEditArea()
        }
        this.openType = type;
        this.visible = true;
      },
      reset() {
        this.ruleForm = {
            address: '',
            zipcode:'',
            consignee: '',
            mobile: '',
            is_default: false,
            province: '',
            city:'',
            district:'',
            town:''
        };
      },
      async submit() {
          const result = await this.$refs.ruleForm.validate()
          if(result) {
              this.ruleForm.is_default = this.ruleForm.is_default ? 1 :0
              const data = await UserCenterService.addressSave(this.ruleForm)
              if(this.openType === 'add') {
                this.$message.success('添加成功！');
                this.$emit('submitSuccess',data)
              }else{
                this.$message.success('修改成功！');
                this.$emit('editSuccess',data)
              }
              this.close();
          }
      },
      async getEditArea() {
          this.province = await UserCenterService.getArea(1,0)
          this.city = await UserCenterService.getArea(2,this.ruleForm.province)
          this.district = await UserCenterService.getArea(3,this.ruleForm.city)
          this.town = await UserCenterService.getArea(4,this.ruleForm.district)
      },
      async getArea(level,id) {
            const data = await UserCenterService.getArea(level,id)
            switch( level ) {
                case 1:
                    this.ruleForm.province = ''
                    this.province = data
                    this.ruleForm.city = ''
                    this.ruleForm.district = ''
                    this.ruleForm.town = ''
                    this.town = []
                    break
                case 2: 
                    this.ruleForm.city = ''
                    this.city = data
                    this.ruleForm.district = ''
                    this.ruleForm.town = ''
                    this.town = []
                    break
                case 3:
                    this.ruleForm.district = ''
                    this.district = data
                    this.ruleForm.town = ''
                    this.town = []
                    break
                case 4: 
                    if(data.length === 0) {
                        this.town = []
                    }else{
                        this.town = data
                    }
                    break
                case 5:
                    this.getArea(5,this.town[0].id)
                    break
            }

        },
        
      // handleRemove(file, fileList) {
      //   if(this.openType === "edit"){
      //     this.displayMap = true
      //   }
      //   this.hideUpload = fileList.length >= this.limitCount
      // },
      // handlePreview(file) {
      //   console.log(file);
      // },
      // beforeUpload(file) {
      // },
      // changeIMG(file,fileList) {
      //   if(this.openType === "edit"){
      //     this.displayMap = false
      //   }
      //   this.hideUpload = fileList.length >= this.limitCount
      //   this.fileData.upfile = file.raw
      // },
      // submitIMG() {
      //   this.$nextTick(() => {
      //       this.$refs.upload.submit()
      //   })
      // },
      // onSuccess(res) {
      //   this.formValue.images_url = res.sub_path
      // },
      close() {
        this.visible = false;
        this.formValue = {};
        this.content = ''
      },
      selectChange() {
        this.$forceUpdate()
      }
    },
    created() {
        this.getArea(1,0)
    }
  }
</script>

<style lang="scss" scoped>

.treeTable {
  height: 29vw;
  overflow-y: auto;
  overflow-x: hidden;
}

</style>

<style lang="scss" scoped>
  .formItemFill .el-dialog__wrapper{
    z-index: 2500!important;
  }
  .rotationChart{
    .el-dialog__wrapper{
      .upload.formItemFill{
        height: 8vw;
        position: relative;
        .el-upload-list__item{
          margin-top: 0;
        }
        .el-button{
          position: absolute;
          top: 0px;
          left: 120px;
        }
      }
      .bg_color.formItemFill{
        height: 8vw;
        .el-color-picker__trigger{
          width: 100%;
          height: 93px;
          margin-top: -3px;
          .el-color-picker__icon{
            display: none;
          }
        }
      }
    }
  }
  .imgBox{
    text-align: left;
    border: 1px solid #e6e6e6;
    height: 6.2vw;
    img{
      height: 6.2vw;
    }
  }
</style>